import moment from "moment";
import { AttendanceType } from "src/redux/types/_attendance.type";
import { Link } from "react-router-dom";
import { Badge } from "src/components/ui/Badge";

const statusColors: Record<string, string> = {
  FULLDAY: "text-green-700 bg-green-50",
  ABSENT: "text-red-700 bg-red-50",
  HALFDAY: "text-yellow-700 bg-amber-50",
};

export const AttendanceTable = ({ data }: { data: AttendanceType[] }) => {
  return (
    <div className="bg-card rounded-xl p-6 shadow-lg">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-gray-600 border-b">
            <th className="py-2 text-left">Emp Code</th>
            <th className="py-2 text-left">Name</th>
            <th className="py-2 text-center">Date</th>
            <th className="py-2 text-center">Check-in Time</th>
            <th className="py-2 text-center">Status</th>
            <th className="py-2 text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row) => (
            <tr
              key={row.id}
              className="border-b last:border-0 hover:bg-gray-50 transition"
            >
              <td className="py-3 font-medium text-gray-900">
                {row.employee_code}
              </td>
              <td className="py-3 font-medium text-gray-900">
                <div>
                  <p>{row.employee_name}</p>
                  <p className="text-xs text-muted">{row.employee_email}</p>
                </div>
              </td>
              <td className="py-3 text-center">
                {moment(row.date).format("MMM Do YY")}
              </td>
              <td className="py-3 text-center">
                {row.attendance_status === "ABSENT"
                  ? "-"
                  : moment(row.checkin_time).format("LT")}
              </td>
              <td className="py-2 text-center">
                <Badge
                  className={`${
                    statusColors[row.attendance_status]
                  } px-3 rounded-full`}
                >
                  {row.attendance_status}
                </Badge>
              </td>
              <td className="text-center">
                <Link
                  to={`/hr/attendance-history/${row.employee_id}/${row.id}?name=${encodeURIComponent(row.employee_name)}&post=${row.employee_post}`}
                  className="text-blue-600 hover:underline"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}

          {data.length === 0 && (
            <tr>
              <td colSpan={8} className="text-center text-gray-500 py-4 italic">
                No employees found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
